<template>
    <table v-if="contacts && contacts.length > 0" class="emergency-contact-table">
        <thead class="table-head">
            <tr class="header-row">
                <th class="">Name</th>
                <th class="">Phone Number</th>
                <th class="">Email</th>
                <th class="">Relationship</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="contact in contacts" :key="contact.contact_id">
                <td class="table-item">{{ contact.contact_first_name }} {{ contact.contact_last_name }}</td>
                <td class="table-item">{{ contact.contact_phone_number }}</td>
                <td class="table-item">{{ contact.contact_email }}</td>
                <td class="table-item">{{ contact.contact_relationship }}</td>
            </tr>
        </tbody>
    </table>
    <div v-else class="empty-container">
        <p>No Emergency Contacts</p>
    </div>
</template>

<script>
export default {
    props: {
        orgaizationData: String,
        userData: String,
        contacts: Array
    },
    data() {
        return {
        }
    },
    methods: {

    }
}
</script>

<style scoped>
.emergency-contact-table {
    display: table;
    width: 100%;
    font-size: 14px;
    color: white;
    table-layout: auto;
    align-items: center;
    border-collapse: collapse;
}

.table-item {
    padding-left: 12px;
    padding-right: 12px;
    text-align: center;
}

.table-head {
    padding-bottom: 8px;
}

.header-row {
    border-bottom: 1px solid #87BAB7;
}

tbody tr:first-child td {
  padding-top: 8px;
}

.emergency-contact-header {}

.empty-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: medium;
}
</style>